import React, { Component } from "react";
import axios from 'axios'
import { BASEURL } from "../Config"
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import swal from 'sweetalert';

class Subjects extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subject: "",
            subjectError: false,
            editableRow: null,
            data: [],
            sub: '',
            id: ''
        }
    }

    componentDidMount() {
        this.receivedData()
    }

    receivedData() {
        axios
            .get(`${BASEURL}/api/v1/subjects/fetchall`)
            .then(res => {
                console.log('res.data', res.data);
                let data = this.state.data;
                data = [];
                for (let i = res.data.length - 1; i >= 0; i--) {
                    data.push(res.data[i]);
                }
                this.setState({
                    data
                })
            });
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
            subjectError: false
        })
    }

    handleUpdateSubjectText(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    validateData() {
        let error = false;
        let subject = this.state.subject;
        if (subject === '') {
            this.setState({
                subjectError: true
            })
            error = true;
        }
        return error;
    }

    handleSubmit() {
        let validationError = this.validateData();
        if (validationError) {
            swal('Error in Adding Subject', 'Fill the required fields', 'error');
        } else {
            let data = {};
            data.subject = this.state.subject;
            axios.post(`${BASEURL}/api/v1/subjects/create`, data)
                .then(res => {
                    if (res.status === 200) {
                        console.log('res.data', res.data);
                        swal("Success", "Subject Added successfully", "success")
                            .then(function () {
                                window.location = "subjects";
                            })
                    } else {
                        console.log('res', res)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data)
                    swal('Error in Adding Subject', err.response.data, 'error');
                    console.log('Create Subject Error', err);
                })
        }
    }

    handleUpdateSubject() {
        console.log('sub id', this.state.sub, this.state.id)
        let input = {};
        input.id = this.state.id;
        input.subject = this.state.sub;

        console.log('update input', input)
        axios.put(`${BASEURL}/api/v1/subjects/update`, input)
            .then(res => {
                if (res.status === 200) {
                    console.log('res.data', res.data);
                    this.receivedData()
                }
            })
            .catch((err) => {
                console.log('Update subject Error', err);
            })
    }

    handleDeleteSubject(sid) {
        axios.delete(`${BASEURL}/api/v1/subjects/delete/${sid}`)
        .then(res => {
            console.log('res.data', res.data);
            swal('Success', 'Subject Deleted successfully', 'success')
            .then(function() {
                window.location.href = 'subjects';
            })
        })
        .catch(err => {
            console.log('err', err);
        })
    }

    render() {
        return (
            <div id="wrapper">
                <Sidebar act="subjects" />
                {/* Content Wrapper */}
                <div className="content-page">
                    {/* Main Content */}
                    <div className="content">
                        <Topbar act="Subjects" breadcrumbItems={["Test Generator", "Subjects"]} />
                        {/* container */}
                        {/* content */}
                        <div className="container-fluid main-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card main-card">
                                        <div className="card-body">
                                            <div className="d-flex">
                                                <div className="col-md-6 mr-2">
                                                    <input type="text" id="subject" className="form-control" onChange={(e) => this.handleChange(e)}
                                                        name="subject" placeholder="Enter Subject"
                                                        defaultValue={this.state.subject} />
                                                </div>
                                                <button type="submit" class="btn btn-customprimary" style={{ opacity: "50%" }} onClick={() => this.handleSubmit()}><i className="mdi mdi-plus-circle  "></i> Add Subject</button>
                                            </div>
                                            {this.state.subjectError ? <p className="errTxt">* required</p> : ''}
                                            {/* end row */}
                                            <table className="table table-centered mb-0 mt-2">
                                                <thead>
                                                    <tr>
                                                        <th>Name of the Subject</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.data.length === 0 ?
                                                        <tr className="text-center"><td colSpan="2">No Subjects added</td></tr> :
                                                        <>
                                                            {this.state.data.map((data, idx) => (
                                                                <tr>
                                                                    <td className="table-user">
                                                                        {this.state.editableRow === idx ?
                                                                            <input type="text" id="subjectname" className="form-control" onChange={(e) => this.handleUpdateSubjectText(e)}
                                                                                name="sub" placeholder="Enter subject Name"
                                                                                defaultValue={data.subject} disabled={this.state.editableRow !== idx} />
                                                                            :
                                                                            <input type="text" id="subjectname" className="form-control" onChange={(e) => this.handleUpdateSubjectText(e)}
                                                                                name="sub" placeholder="Enter subject Name"
                                                                                value={data.subject} disabled={this.state.editableRow !== idx} />
                                                                        }
                                                                    </td>
                                                                    <td >
                                                                        {this.state.editableRow === idx ?
                                                                            <button className="btn btn-new brn-sm table_Action_btns" onClick={() => { this.handleUpdateSubject(); this.setState({ editableRow: null }); }}><i className="mdi mdi-content-save-outline" />save</button> :
                                                                            <button className="btn"
                                                                                onClick={() => { this.setState({ editableRow: idx, id: data._id, sub: data.subject }) }}>
                                                                                <i className="mdi mdi-pencil" /></button>}
                                                                        <button className="btn" onClick={() => this.handleDeleteSubject(data._id)}> <i className="mdi mdi-delete" /></button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                        </div> {/* end card-body */}
                                    </div> {/* end card*/}
                                </div> {/* end col*/}
                            </div>
                            {/* end row*/}
                        </div>
                        {/* End of Main Content */}
                        <Footer />
                    </div>
                    {/* End of Content Wrapper */}
                </div>
            </div>
        )
    }
}

export default Subjects;